import moment from 'moment'
import Cryptr from 'cryptr'
import { get } from 'lodash'
const cryptr = new Cryptr('myTotalySecretKey')

export default function storeAwsTokenData() {
  return new Promise((resolve, reject) => {
    var url = window.location.href
    var urlSpiltData = url.split('/')
    const authuser = JSON.parse(localStorage.getItem('AuthResponse'))

    var jwtToken = ''
    var username = ''
    var password = ''

    jwtToken = urlSpiltData[4]
    username = get(authuser, 'attributes.email', '')
    password = urlSpiltData[6]

    var currentDate = moment().format('YYYY-MM-DDTHH:mm:ssZ')
    var expireTokenDate = moment(currentDate).add(55, 'minutes').format('YYYY-MM-DDTHH:mm:ssZ')

    var loginRequestData = {
      username: username,
      password: password,
    }

    localStorage.setItem('accessToken', jwtToken)

    //localStorage.setItem('expireAwsTokenDate', expireTokenDate);

    resolve(loginRequestData)
  })
}
